import { render } from "./CreateOrUpdateDistrictModal.vue?vue&type=template&id=6b9b80e8"
import script from "./CreateOrUpdateDistrictModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateDistrictModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__